import { statusLabels, tableLabels } from "@revbox/localization";
import { ClusterActionCellTooltipRenderer, ClusterActionRenderer, ClusterActionCellColumnHeaderTooltipRenderer } from "../ClusterActionRenderer";
import { MissedClicksForecastCellColumnHeaderTooltipRenderer, MissedClicksForecastCellTooltipRenderer, MissedClicksForecastRenderer } from "../ClusterMissedClicksForecastRenderer";
import { ClusterNameCellTooltipRenderer, ClusterNameColumnHeaderTooltipRenderer, ClusterNameRenderer } from "../ClusterNameRenderer";
import { ClusterPositionCellTooltipRenderer, ClusterPositionRenderer, PositionColumnHeaderTooltipRenderer } from "../ClusterPositionRenderer";
import { StatusCellTooltipRenderer, StatusRenderer, StatusColumnHeaderTooltipRenderer } from "../ClusterStatusRenderer";
import { TopBidCellRenderer, TopBidCellTooltipRenderer, TopBidColumnHeaderTooltipRenderer } from "../ClusterTopBidRenderer";
import { ClusterYourBidCellRenderer, ClusterYourBidCellTooltipRenderer, YourBidColumnHeaderTooltipRenderer } from "../ClusterYourBidRenderer";
import { createClusterClasses } from "../cluster-classes";
import { getServerSideDatasourceClusterPPC } from "@revbox/helpers-fe";

export const getCustomColumns = () => [
    {
      field: "Topic",
      cellRenderer: ClusterNameRenderer,
      headerTooltip: ClusterNameColumnHeaderTooltipRenderer(),
      tooltipValueGetter: ClusterNameCellTooltipRenderer,
      rowGroup: true,
      hide: true,
    },
    {
      field: "Position",
      cellRenderer: ClusterPositionRenderer,
      headerTooltip: PositionColumnHeaderTooltipRenderer(),
      tooltipValueGetter: ClusterPositionCellTooltipRenderer,
    },
    {
      field: "Status",
      cellRenderer: StatusRenderer,
      headerTooltip: StatusColumnHeaderTooltipRenderer(),
      tooltipValueGetter: StatusCellTooltipRenderer,
    },
    {
      field: "Your Bid",
      cellRenderer: ClusterYourBidCellRenderer,
      headerTooltip: YourBidColumnHeaderTooltipRenderer(),
      tooltipValueGetter: ClusterYourBidCellTooltipRenderer,
    },
    {
      field: "Top Bid",
      cellRenderer: TopBidCellRenderer,
      headerTooltip: TopBidColumnHeaderTooltipRenderer(),
      tooltipValueGetter: TopBidCellTooltipRenderer,
    },
    {
      field: "Action",
      cellRenderer: ClusterActionRenderer,
      headerTooltip: ClusterActionCellColumnHeaderTooltipRenderer(),
      tooltipValueGetter: ClusterActionCellTooltipRenderer,
    },
    {
      field: "Click Opportunity",
      cellRenderer: MissedClicksForecastRenderer,
      headerTooltip: MissedClicksForecastCellColumnHeaderTooltipRenderer(),
      tooltipValueGetter: MissedClicksForecastCellTooltipRenderer,
    },
  ]
  
  export const defaultColDef = {
    flex: 1,
    minWidth: 90,
  };
  
  export const getAutoGroupColumnDef = (languageAbbr) => {
    return {
      headerName: tableLabels[languageAbbr]["Topic"],
      field: "name",
      pinned: "left",
      cellRendererParams: {
        suppressCount: true,
      },
      tooltipValueGetter: ClusterNameCellTooltipRenderer,
      cellRendererSelector: (params) => {
        return {
          component: ClusterNameRenderer,
        };
      },
      suppressHeaderFilterButton: true,
      sortable: false,
      menuTabs: [],
      suppressMenu: true,
      minWidth: 340,
      width: 340,
    }
  }
  
  export const getRowClass = (params) => {
    if (!params.data) return '';
    const classes = createClusterClasses(params);
    return Object.entries(classes)
      .filter(([_, isTrue]) => isTrue)
      .map(([className]) => className)
      .join(' ');
  }
  
  export const setIdToTourElement = () => {
    const firstButton = document.querySelector("#start-bidding");
    if (firstButton) {
      firstButton.setAttribute("id", "bidding-button");
    }
  }
  
  export const filterAuctions = (
    rows,
    search,
    languageAbbr
  ) => {
    const translate = statusLabels[languageAbbr];
    const activeLabel = translate["Bid Active"];
    const inheritedLabel = translate["Inherited"];
  
    const activeAuctions = [];
    const inheritedAndNotShown = [];

    for (const row of rows) {
      const { status, position } = row;
  
      if (!search && status.includes(activeLabel)) {
        activeAuctions.push(row);
      }
  
      if (status.includes(inheritedLabel)) {
        const tooltip = ClusterPositionCellTooltipRenderer({ value: position });
        if (tooltip.includes("not shown")) {
          inheritedAndNotShown.push(row);
        }
      }
    }
  
    return { activeAuctions, inheritedAndNotShown };
  };
  
  export const fetchClusterAuctions = async (
    getData,
    setColumnDefs,
    search,
    campaignId,
    languageAbbr,
    statusFilter
  ) => {
    return await getServerSideDatasourceClusterPPC(
      getData,
      setColumnDefs,
      search,
      getCustomColumns(),
      campaignId,
      languageAbbr,
      statusFilter
    );
  };